// NOTE: NSAI-7336 — Deep Research's source favicons come from our own API,
// which fetches and caches them, so no browser or phone asks a source's site
// (or an icon service) for one.
export const RESEARCH_FAVICONS_API_PATH = "/research/favicons";

export const RESEARCH_FAVICON_QUERY_KEY = "research-favicon";

// NOTE: The server's cap on hosts per request.
export const RESEARCH_FAVICONS_MAX_HOSTS_PER_REQUEST = 40;

// NOTE: How long the loader collects the badges rendered together before it
// asks — a status line's stack, a panel's chips and rows arrive in one go.
export const RESEARCH_FAVICONS_BATCH_DELAY_MS = 20;
